import * as React from 'react';
import { Box, ButtonBase, ButtonBaseProps } from '@mui/material';
import { Add } from '@mui/icons-material';

type CrystalButtonProps = ButtonBaseProps;

export const CrystalButton = (props: CrystalButtonProps) => {
  return (
    <ButtonBase {...props}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(-45deg, rgba(255,137,0,1) 0%, rgba(255,137,0,1) 50%, rgba(255,169,34,1) 50%, rgba(255,169,34,1) 100%)`,
          width: 30,
          height: 30,
          borderRadius: 0.5,
        }}
      >
        <Add sx={{ color: 'white' }} />
      </Box>
    </ButtonBase>
  );
};
